import { Box, Modal as ModalBase } from "@mui/material";
import { FC } from "react";
import { getModalStyle, StyledText } from "./styles";
import { Close } from "@mui/icons-material";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  size?: "small" | "medium" | "large";
  hideCloseButton?: boolean;
  disableAutoFocus?: boolean;
};

export const Modal: FC<ModalProps> = ({
  title,
  open,
  onClose,
  children,
  size = "medium",
  hideCloseButton = false,
  disableAutoFocus = false,
}) => {
  const style = getModalStyle(size);
  return (
    <ModalBase
      open={open}
      onClose={hideCloseButton ? undefined : onClose}
      disableAutoFocus={disableAutoFocus}
      disableEnforceFocus={disableAutoFocus}
      disableRestoreFocus={disableAutoFocus}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {!hideCloseButton && (
        <Box>
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              border: "none",
              background: "none",
              cursor: "pointer",
            }}
          >
            <Close />
          </button>
        </Box>
        )}
        <StyledText id="modal-modal-title">{title}</StyledText>
        <Box id="modal-modal-description" sx={{ overflowY: "auto" }}>
          {children}
        </Box>
      </Box>
    </ModalBase>
  );
};
